{
  "name": "videojs-vtt-thumbnails",
  "version": "0.0.14",
  "description": "Display thumbnails on progress bar hover, driven by external VTT files.",
  "main": "index.js",
  "type": "module",
  "engines": {
    "node": ">=14"
  },
  "repository": {
    "type": "git",
    "url": "https://github.com/trex-arms/videojs-vtt-thumbnails.git"
  },
  "license": "MIT"
}
